import { styled, TableRow as UiTableRow } from '@ethings/ui-toolkit';
import { TableRow as MUITableRow } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

interface Props extends PropsWithChildren {
  hover?: boolean;
  link?: string;
  'data-testid'?: string;
  state?: Record<string, string>;
  sx?: SxProps;
}

const StyledTableRow = styled(UiTableRow)() as typeof MUITableRow;

export const TableRow: FC<Props> = ({ children, link, hover, state, sx, ...props }) => {
  const styles: SxProps = {
    '@media (max-width: 600px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      width: '100%',
    },
    ...(link ? { cursor: 'pointer', textDecoration: 'none' } : {}),
    ...sx,
  };

  if (link) {
    return <StyledTableRow {...props} hover={hover} to={link} state={state} component={Link} sx={styles}>{children}</StyledTableRow>;
  }

  return <StyledTableRow {...props} hover={hover} component='div' sx={styles}>{children}</StyledTableRow>;
};
